export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_riskCheckNo') || '核查记录号',
    field: 'riskCheckNo',
    minWidth: 160,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '客户公司名称',
    field: 'custName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_businessLicense') || '客户税号',
    field: 'businessLicense',
    minWidth: 160,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_region') || '所在国家',
    field: 'regionName',
    minWidth: 100,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_riskCheckStatus') || '检查状态',
    field: 'riskCheckStatus',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'riskCheckStatus' },
  },
  {
    title: that.$l('table_label_riskLevel') || '检查结果',
    field: 'riskLevel',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'riskLevel' },
  },
  {
    title: that.$l('table_label_displayRiskCheckBy') || '核查人',
    field: 'displayRiskCheckBy',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'displayRiskCheckBy' },
  },
  {
    title: that.$l('table_label_displayCreateBy') || '提交人',
    field: 'displayCreateBy',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'displayCreateBy' },
  },
  {
    title: that.$l('table_label_displayModifyBy') || '修改人',
    field: 'displayModifyBy',
    align: 'left',
    minWidth: 170,
    showHeaderOverflow: true,
    slots: { default: 'displayModifyBy' },
  },
]
